import { type SVGProps } from 'react';

export const ChevronIcon: React.FC<SVGProps<SVGSVGElement> & { strokeWidth?: number }> = ({
  strokeWidth = 3,
  width = 10,
  ...props
}) => (
  <svg fill="none" viewBox="0 0 24 24" width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 8L12 16L20 8" stroke="currentColor" strokeWidth={strokeWidth} />
  </svg>
);
